<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="项目名称">
              <a-input placeholder="请输入项目名称" v-model="queryParam.name"></a-input>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="项目code">
              <a-input placeholder="请输入项目code" v-model="queryParam.code"></a-input>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="项目状态 ">
              <a-select placeholder="请选择" v-model="queryParam.status" allowClear>
                <a-select-option v-for="(item,index) in statusData" :key="index" :value="item">
                  {{item.text}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
                  <a-button @click="handleAdd" type="primary" icon="plus" style="margin-left: 8px">新增</a-button>
                </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"

        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        <span slot="status" slot-scope="text, record">
          <project-status :status="text"></project-status>
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="infoSet(record)">进入项目</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                  <a @click="handleEdit(record)">编辑</a>
              </a-menu-item>
              <!-- <a-menu-item>
                  <a @click="handleGroup(record.id)">访视分组</a>
              </a-menu-item> -->
              <a-menu-item>
                  <a @click="handlePatientCheckView(record.id)">患者信息规则</a>
              </a-menu-item>
               <a-menu-item>
                  <a @click="handleWechatConfig(record)">微信配置</a>
              </a-menu-item> 
              <a-menu-item v-if="record.wechatId">
                  <a @click="getQrcodeView(record)">微信二维码</a>
              </a-menu-item>
              <a-menu-item>
                  <a @click="handleVoiceConfig(record)">语音配置</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>
    <!-- table区域-end -->
    <!-- 表单区域 -->
    <project-modal ref="modalForm" @ok="modalFormOk"></project-modal>
    <project-visit-form-group-list ref="visitFormGroup"></project-visit-form-group-list>
    <wechat-config ref="wechatConfig" @ok="modalFormOk"></wechat-config>
    <voice-config ref="voiceConfig" @ok="modalFormOk"></voice-config>
    <patient-check-config ref="patientCheck" ></patient-check-config>
    <a-modal
      title="微信二维码"
      :width="350"
      :visible="qrCodeVisible"
      switchFullscreen
      @ok="qrCodeVisible = false"
      @cancel="qrCodeVisible = false"
      cancelText="关闭">
      <div style="padding: 20px;color: red">
        扫描该二维码将会自动注册受试者、自动筛选通过、自动推送表单
      </div>
      <img v-if="qrCodeUrl " :src="qrCodeUrl" style="width:300px;height:300px"/>
    </a-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import ProjectModal from './modules/ProjectModal'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import ProjectStatus from './projectList/ProjectStatus'
  import { CACHE_PROJECT_ID,CACHE_PROJECT_NAME,statusData } from '@/constants/project'
  import Vue from 'vue'
  import ProjectVisitFormGroupList from './visitformgroup/ProjectVisitFormGroupList'
  import WechatConfig from './modules/WechatConfig'
  import VoiceConfig from './modules/VoiceConfig'
  import PatientCheckConfig from './modules/PatientCheckConfig'
  import { getAction } from '@/api/manage'

  export default {
    name: "ProjectList",
    mixins:[JeecgListMixin],
    components: {
      PatientCheckConfig,
      WechatConfig,
      VoiceConfig,
      ProjectVisitFormGroupList,
      ProjectStatus,
      ProjectModal
    },
    inject:['changeProjectName'],
    data () {
      return {
        qrCodeVisible:false,
        qrCodeUrl:'',
        patientCheckVisit:false,
        description: '项目管理管理页面',
        statusData:statusData,
        // 表头
        columns: [
          {
            title: '项目名称',
            align:"center",
            dataIndex: 'name'
          },
          // {
          //   title: '项目CODE',
          //   align:"center",
          //   dataIndex: 'code'
          // },
          {
            title: '项目状态',
            align:"center",
            dataIndex: 'status',
            scopedSlots: { customRender: 'status' },
          },
          // {
          //   title: '项目首次启动时间',
          //   align:"center",
          //   dataIndex: 'startDate'
          // },
          //
          // {
          //   title: '预计结束时间',
          //   align:"center",
          //   dataIndex: 'planEndDate'
          // },
          // {
          //   title: '实际结束时间',
          //   align:"center",
          //   dataIndex: 'endDate'
          // },
          // {
          //   title: '项目计划天数（用来计算项目结束时间）暂时无用',
          //   align:"center",
          //   dataIndex: 'planDays'
          // },
          // {
          //   title: '项目简介',
          //   align:"center",
          //   dataIndex: 'intro'
          // },
          {
            title: '项目负责人',
            align:"center",
            dataIndex: 'contactName'
          },
          {
            title: '项目联系电话',
            align:"center",
            dataIndex: 'contactPhone'
          },
          {
            title: '研究类型',
            align:"center",
            dataIndex: 'researchType'
          },
          {
            title: '设计方案',
            align:"center",
            dataIndex: 'designScheme'
          },
          {
            title: '设计模式',
            align:"center",
            dataIndex: 'designModal'
          },
          {
            title: '总样本量',
            align:"center",
            dataIndex: 'sampleCount'
          },
          {
            title: '项目申办人',
            align:"center",
            dataIndex: 'projectCreateUserName'
          },
          {
            title: '创建时间',
            align:"center",
            dataIndex: 'createTime'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' },
          }
        ],
        url: {
          list: "/management/project/list",
          delete: "/management/project/delete",
        },
      }
    },
    computed: {
    },
    mounted(){
    },
    methods: {
      handleGroup(projectId){
          this.$refs.visitFormGroup.view(projectId)
      },
      infoSet(record){
        this.$confirm({
          title: '提示',
          content: `当前是否切换项目到：${record.name}?`,
          onOk:()=> {
            Vue.ls.set(CACHE_PROJECT_ID,record.id)
            Vue.ls.set(CACHE_PROJECT_NAME,record.name)
            this.$router.push({path:this.$route.query.redirect || '/project/setting/info'})
            this.changeProjectName(record.name)
          },
          onCancel() {
          },
        });

      },
      handleWechatConfig(record){
        this.$refs.wechatConfig.view(record)
      },
      handleVoiceConfig(record){
        this.loading = true
        getAction('/project/voiceConfig/listAll',{projectId:record.id}).then(res=>{
          if(res.success&&res.result.length>0){
            record.voice="1"
            let voiceItems=[]
            res.result.forEach(item=>{voiceItems.push(item.name)})
          record.voiceIds=voiceItems
          }else{
            record.voice="0"
          }
          this.$refs.voiceConfig.view(record)
        }).finally(()=>{
          this.loading = false
        })
        
      },
      getQrcodeView(record){
        this.loading = true
        getAction('/wechat/getForeverTicket',{projectId:record.id}).then(res=>{
          if(res.success){
            this.qrCodeVisible = true
            this.qrCodeUrl = res.result
          }else{
            return this.$message.error(res.message)
          }
        }).finally(()=>{
          this.loading = false
        })
      },
      handlePatientCheckView(id){
        this.$refs.patientCheck.view(id)
      }
    },
    beforeDestroy(){
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>